import axios from 'axios'
import {
	Message,
	MessageBox
} from 'element-ui'
import store from '../store'
import {
	getToken
} from '@/utils/auth'
// export const baseURL = process.env.BASE_API;
export const baseURL = process.env.NODE_ENV === 'development' ? '/api' : '/api';
// 创建axios实例
const service = axios.create({
	// baseURL: process.env.BASE_API, // api的base_url
  baseURL: baseURL, // api的base_url
	timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
	if (store.getters.token) {
		config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // config.headers['Content-Type'] = 'application/json'
	}
	return config
}, error => {
	// Do something with request error
	console.log(error) // for debug
	Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
	response => {
		/**
		 * code为非200是抛错 可结合自己业务进行修改
		 */
		const res = response

  //   // console.log('res',res.data)
  //   if (res.data.status == 201) {
  //     Message.error(res.data.msg);
  //   }

		if (res.status !== 200) {
			Message({
				message: res.msg,
				type: 'error',
				duration: 3 * 1000
			})

			// 401:未登录;
			if (res.status === 401) {
				MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
					confirmButtonText: '重新登录',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					store.dispatch('FedLogOut').then(() => {
						location.reload() // 为了重新实例化vue-router对象 避免bug
					})
				})
			}
			return Promise.reject('error')
		} else {
			return response
		}
	},
	error => {
		console.log('err' + error) // for debug
		Message({
			message: error.message,
			type: 'error',
			duration: 3 * 1000
		})
		return Promise.reject(error)
	}
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js